import React, { memo } from 'react';
import classnames from 'classnames';
import { getDonorUnitFromBundleMembers, getInactiveAndActiveSwVersions } from 'common/utils/helpers';
import { getModelFromProductType, getGenFromProductType } from 'common/utils/deviceTwinUtils';
import BundleOverviewControllerSwUpdateActionContainer from '../BundleOverviewControllerSwUpdateActionContainer/BundleOverviewControllerSwUpdateActionContainer';
import BundleOverviewControllerDMActions from '../BundleOverviewControllerDMActions/BundleOverviewControllerDMActions';
import BundleOverviewControllerDeviceName from '../BundleOverviewControllerDeviceName/BundleOverviewControllerDeviceName';

const BundleOverviewControllerHub = (props) => {
  const getDonorUnit = () => {
    if (props.isGa2) {
      return props.device;
    }

    return props.bundleMembers && getDonorUnitFromBundleMembers(props.bundleMembers);
  };

  const isPivotHub = props.deviceType === 'pivot';
  const donorUnit = getDonorUnit();
  const siteId = props.bundle?.code
    ? props.bundle.code
    : getDonorUnitFromBundleMembers(props.bundle?.members)?.tags?.bundle?.code || 'Pod_Unknown';
  const deviceTypeTitle = !isPivotHub ? 'Model' : 'Device Type';
  const deviceTypeLabel = !isPivotHub
    ? getModelFromProductType(props.device?.properties?.reported?.productType)
    : donorUnit?.properties?.reported?.productType ?? 'Unknown';
  const swVersions = getInactiveAndActiveSwVersions(isPivotHub ? donorUnit : props.device);
  const triangleDiv = (
    <div className="BundleOverviewController_ArrowDown" id="BundleOverviewController_ArrowDown"></div>
  );

  return (
    <div
      id="BundleOverviewControllerHub"
      className={classnames('BundleOverviewControllerHub', {
        BundleOverviewControllerTabFocus: props.activeIndex === null
      })}
      onClick={() => {
        props.sendSelectedDevice(null);
        props.setActiveIndex(null);
      }}
    >
      {props.activeIndex === null && triangleDiv}

      <div id="BundleOverviewControllerHubTop" className="BundleOverviewControllerHubTop">
        <BundleOverviewControllerDeviceName
          bundle={props.bundle}
          device={props.device}
          deviceType={props.deviceType}
          isGa2={props.isGa2}
        />
      </div>
      <div id="BundleOverviewControllerHubMiddle" className="BundleOverviewControllerHubMiddle">
        {isPivotHub && (
          <div id="BundleOverviewControllerHubDetail_SiteId" className="BundleOverviewControllerHubDetail_SiteId">
            <div
              id="BundleOverviewControllerHubDetailTitle"
              className="BundleOverviewControllerHubDetailTitle"
              data-tip={'Site ID'}
            >
              Site ID
            </div>
            <div
              id="BundleOverviewControllerHubDetailLabel"
              className="BundleOverviewControllerHubDetailLabel"
              data-tip={siteId}
            >
              {siteId}
            </div>
          </div>
        )}
        <div
          id={isPivotHub ? 'BundleOverviewControllerHubDetail_Gen' : 'BundleOverviewControllerHubDetail_Model'}
          className={classnames({
            BundleOverviewControllerHubDetail_Gen: isPivotHub,
            BundleOverviewControllerHubDetail_Model: !isPivotHub
          })}
        >
          <div
            id="BundleOverviewControllerHubDetailTitle"
            className="BundleOverviewControllerHubDetailTitle"
            data-tip={deviceTypeTitle}
          >
            {deviceTypeTitle}
          </div>
          <div
            id="BundleOverviewControllerHubDetailLabel"
            className="BundleOverviewControllerHubDetailLabel"
            data-tip={deviceTypeLabel}
          >
            {deviceTypeLabel}
          </div>
        </div>
        <BundleOverviewControllerDMActions
          bundle={props.bundle}
          bundleMembers={props.bundleMembers}
          isGa2={props.isGa2}
          device={props.device}
          isPivotHub={isPivotHub}
          action={props.latestActiveAction}
        />
      </div>
      <div id="BundleOverviewControllerHubBorderDivider" className="BundleOverviewControllerHubBorderDivider"></div>
      <div id="BundleOverviewControllerHubBottom" className="BundleOverviewControllerHubBottom">
        <div id="BundleOverviewControllerHubDetail_SwRelease" className="BundleOverviewControllerHubDetail_SwRelease">
          <div
            id="BundleOverviewControllerHubDetailTitle"
            className="BundleOverviewControllerHubDetailTitle"
            data-tip={'System SW Release'}
          >
            System SW Release
          </div>
          <div
            id="BundleOverviewControllerHubDetailLabelSwControl"
            className="BundleOverviewControllerHubDetailLabelSwControl"
          >
            <div id="BundleOverviewControllerHubDetailLabel" className="BundleOverviewControllerHubDetailLabel">
              <div
                id="BundleOverviewControllerHubDetailLabelSwControl_SwVersion"
                className="BundleOverviewControllerHubDetailLabelSwControl_SwVersion"
              >
                <div
                  id="BundleOverviewControllerHubDetailLabelSwControl_SwVersion_Title_Box"
                  className="BundleOverviewControllerHubDetailLabelSwControl_SwVersion_Title_Box"
                >
                  <span
                    id="BundleOverviewControllerHubDetailLabelSwControl_SwVersion_Title"
                    className="BundleOverviewControllerHubDetailLabelSwControl_SwVersion_Title"
                    data-tip={'ACTIVE'}
                  >
                    ACTIVE
                  </span>
                </div>
                <div
                  id="BundleOverviewControllerHubDetailLabelSwControl_SwVersion_Label"
                  className="BundleOverviewControllerHubDetailLabelSwControl_SwVersion_Label"
                  data-tip={swVersions.active}
                >
                  {swVersions.active}
                </div>
              </div>
              <div
                id="BundleOverviewControllerHubDetailLabelSwControl_SwVersion"
                className="BundleOverviewControllerHubDetailLabelSwControl_SwVersion"
              >
                <div
                  id="BundleOverviewControllerHubDetailLabelSwControl_SwVersion_Title_Box"
                  className="BundleOverviewControllerHubDetailLabelSwControl_SwVersion_Title_Box"
                >
                  <span
                    id="BundleOverviewControllerHubDetailLabelSwControl_SwVersion_Title"
                    className="BundleOverviewControllerHubDetailLabelSwControl_SwVersion_Title"
                    data-tip={'INACTIVE'}
                  >
                    INACTIVE
                  </span>
                </div>
                <div
                  id="BundleOverviewControllerHubDetailLabelSwControl_SwVersion_Label"
                  className="BundleOverviewControllerHubDetailLabelSwControl_SwVersion_Label"
                  data-tip={swVersions.inactive}
                >
                  {swVersions.inactive}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="BundleOverviewControllerHubDetail">
          <div className="BundleOverviewControllerHubDetailMap"></div>
        </div> */}
        <BundleOverviewControllerSwUpdateActionContainer
          bundle={props.bundle}
          bundleMembers={props.bundleMembers}
          isGa2={props.isGa2}
          device={props.device}
          isPivotHub={isPivotHub}
        />
      </div>
    </div>
  );
};

export default memo(BundleOverviewControllerHub);
